import { useState, useEffect, useRef } from "react";
import {
    TbLayoutNavbarCollapseFilled,
    TbLayoutNavbarExpandFilled,
} from "react-icons/tb";

import "./Collapsable.css";

interface Props {
    title: string;
    children: React.ReactNode;
}

export function Collapsable({ title, children }: Props) {
    //return <div className="collapsable-container">{children}</div>;
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [maxHeight, setMaxHeight] = useState("0px");

    const bodyRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!bodyRef.current) return;

        const updateHeight = () => {
            if (isCollapsed) setMaxHeight("0px");
            else setMaxHeight(`${bodyRef.current?.scrollHeight}px`);
        };

        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(bodyRef.current);

        return () => observer.disconnect();
    }, [isCollapsed]);

    return (
        <div className="collapsable-container">
            <div
                className="collapsable-header"
                onClick={() => setIsCollapsed((prev) => !prev)}
            >
                {isCollapsed ? (
                    <TbLayoutNavbarExpandFilled />
                ) : (
                    <TbLayoutNavbarCollapseFilled />
                )}
                <span>{title}</span>
            </div>
            <div
                className="collapsable-body"
                style={{ maxHeight: maxHeight }}
                ref={bodyRef}
            >
                {children}
            </div>
        </div>
    );
}
